import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import platformConfig from 'src/platform-config'
import { i18nObject } from 'boot/i18n'

const config = platformConfig.configs(process.env.PLATFORM)
export const useMainStore = defineStore('main', () => {
  const info = ref({})
  const appConfig = ref({
    titlePure: config.title,
    name: config.shortTitle,
    addressBarColor: config.addressBarColor,
    links: {
      baseLink: config.links.baseLink,
      support: config.links.support,
      help: config.links.help,
    },
    meta: config.meta,
    mainGroups: [],
  })

  const a_ssid = ref('')
  const app_type = ref('')
  const mb_uuid = ref('')

  const getAppConfig = computed(() => {
    return appConfig.value
  })
  const getMainGroups = computed(() => {
    return appConfig.value.mainGroups
  })

  const getAssid = computed(() => {
    return a_ssid.value || localStorage?.getItem('a_ssid') || sessionStorage.getItem('a_ssid') || ''
  })
  const getAppType = computed(() => {
    return app_type.value || localStorage?.getItem('app_type') || sessionStorage.getItem('app_type') || null
  })
  const getMbUuid = computed(() => {
    return mb_uuid.value || localStorage?.getItem('mb_uuid') || sessionStorage.getItem('mb_uuid') || null
  })

  function clear() {
    a_ssid.value = ''
    app_type.value = ''
    mb_uuid.value = ''
    if (localStorage) {
      localStorage.removeItem('a_ssid')
      localStorage.removeItem('app_type')
      localStorage.removeItem('mb_uuid')
    }
    if (sessionStorage) {
      sessionStorage.removeItem('a_ssid')
      sessionStorage.removeItem('app_type')
      sessionStorage.removeItem('mb_uuid')
    }
  }

  function updateAssid(payload) {
    a_ssid.value = payload
    if (localStorage) {
      localStorage.setItem('a_ssid', payload)
    }
    if (sessionStorage) {
      sessionStorage.setItem('a_ssid', payload)
    }
  }

  function updateAppType(payload) {
    app_type.value = payload
    if (localStorage) {
      localStorage.setItem('app_type', payload)
    }
    if (sessionStorage) {
      sessionStorage.setItem('app_type', payload)
    }
  }

  function updateMbUuid(payload) {
    mb_uuid.value = payload
    if (localStorage) {
      localStorage.setItem('mb_uuid', payload)
    }
    if (sessionStorage) {
      sessionStorage.setItem('mb_uuid', payload)
    }
  }

  function updateMainGroups() {
    appConfig.value.mainGroups = [
      {
        slug: 'slot',
        label: i18nObject.global.t('slots'),
        name: 'GamesByGroup',
      },
      {
        slug: 'online',
        label: i18nObject.global.t('live_casino'),
        name: 'GamesByGroup',
      },
      {
        slug: 'fast',
        label: i18nObject.global.t('instant'),
        name: 'GamesByGroup',
      },
      {
        slug: 'table',
        label: i18nObject.global.t('table'),
        name: 'GamesByGroup',
      },
      {
        slug: 'lottery',
        label: i18nObject.global.t('lottery'),
        name: 'GamesByGroup',
      },
      {
        slug: 'vsport',
        label: i18nObject.global.t('virtuals'),
        name: 'GamesByGroup',
      },
    ]
  }

  return {
    // refs
    appConfig,
    info,
    a_ssid,
    app_type,
    mb_uuid,
    // computed
    getAppConfig,
    getMainGroups,
    getAssid,
    getAppType,
    getMbUuid,
    //functions
    updateMainGroups,
    clear,
    updateAssid,
    updateAppType,
    updateMbUuid,
  }
})
